import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e072b406&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e072b406')) {
      api.createRecord('e072b406', component.options)
    } else {
      api.reload('e072b406', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=e072b406&", function () {
      api.rerender('e072b406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/App.vue"
export default component.exports